import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class BillingService {

  public URLconnect = environment.URL_API;

  constructor(private http: HttpClient) {}

  async renewCycle(clientId: string, reason: string = "normal") {
    try {
      const response = await this.http.post<{ code: number, data: any }>(
        this.URLconnect + "/billing/renew",
        { clientId, reason }
      ).toPromise();

      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async getActiveCycles() {
    try {
      const response = await this.http.get<{ code: number, data: any[] }>(
        this.URLconnect + "/billing/active"
      ).toPromise();

      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async updateBillingCycle(
    cycleId: string,
    payload: any
  ) {

    return this.http.put(
      `${this.URLconnect}/billing/cycle/${cycleId}`,
      payload
    ).toPromise();
  }

  async deleteCycle(cycleId: string) {

    return this.http.delete(
      `${this.URLconnect}/billing/cycle/${cycleId}`
    ).toPromise();
  }
}